import configService from './configService';
import configTemplate from './marketConfigs/configTemplate';

const config = {...configTemplate};

const initConfig = async () => {
    const configData = await configService.getConfigData();

    config.data = {...config.data, ...configData};
};

export {config, initConfig};
